// utils.ts

/**
 * Делает цвет из темы полупрозрачным.
 *
 * В коде было около шестидесяти одиночных значений вида
 * rgba(114, 82, 220, 0.3) — те же цвета, что уже есть в теме, только
 * с другой прозрачностью. Заводить под каждое отдельный токен значит
 * превратить палитру в свалку; вместо этого прозрачность считается
 * от базового токена.
 *
 * Понимает форматы rgb(), rgba() и #rrggbb.
 */
export const withAlpha = (color: string, alpha: number): string => {
  const rgbMatch = color.match(
    /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*[\d.]+\s*)?\)$/,
  );
  if (rgbMatch) {
    const [, r, g, b] = rgbMatch;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  const hexMatch = color.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (hexMatch) {
    const hex = hexMatch[1];
    const full =
      hex.length === 3
        ? hex
            .split("")
            .map((c) => c + c)
            .join("")
        : hex;
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // Неизвестный формат оставляем как есть: лучше без прозрачности,
  // чем сломанное значение в CSS.
  return color;
};

export const pxToRem = (value: number | string | undefined): string | undefined => {
  const baseFontSize = 10; // При font-size: 62.5% базовый размер равен 10px

  if (value === undefined) {
    return undefined;
  }

  let numericValue: number;

  if (typeof value === "number") {
    numericValue = value;
  } else if (typeof value === "string") {
    // Удаляем пробелы и суффикс "px", если он присутствует
    const cleanedValue = value.trim().toLowerCase().replace("px", "");
    numericValue = parseFloat(cleanedValue);
    if (isNaN(numericValue)) {
      return "0rem";
    }
  } else {
    return "0rem";
  }

  return `${numericValue * 1 / baseFontSize}rem`;
};
